import styled from "styled-components";
import { error } from "loglevel";

const FieldErrorBox = styled.div`
  display: ${props => props.$inline ? 'inline-block' : 'block'};
  margin-left: ${props => props.$inline ? '6px' : '0px'};
`;

const Error = styled.label`
  // background: lightgrey;
  display: ${props => props.$inline ? 'inline' : 'block'};
  // min-height: ${props => props.$inline ? '0px' : '14px'};
  min-height: ${({ $size = 12, $inline }) => $inline ? '0px' : `${Math.ceil($size * 1.0)}px`};
  line-height: ${({ $size = 12 }) => Math.ceil($size * 1.0)}px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: ${props => props.$size ?? 12}px;
  color: red;
`;

export const FieldError = ({ message, size = 12, inline = false }) => {
  return(
    <FieldErrorBox $inline={inline}>
      <Error $size={size} $inline={inline}>
        {message ? `(${message})` : ''}
      </Error>
    </FieldErrorBox>
  );
};

export const FieldErrors = ({ errors, size = 12, inline = false }) => {
  return(
      <FieldErrorBox $inline={inline}>
        {errors?.map(error => (
            <Error key={error.code} $size={size} $inline={inline}>{error.message}</Error>
        ))}
      </FieldErrorBox>
  );
};